(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["darbu-galerija"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.agInit) return;
    root.dataset.agInit = '1';
    var track = root.querySelector('[data-ag-track]');
    var prev = root.querySelector('[data-ag-prev]');
    var next = root.querySelector('[data-ag-next]');
    if (!track) return;
    function step() { return track.querySelector('.ag-gallery__slide') ? track.querySelector('.ag-gallery__slide').getBoundingClientRect().width : track.clientWidth; }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 5; }
    function goPrev() { track.scrollBy({ left: -step(), behavior: 'smooth' }); }
    function goNext() {
      if (atEnd()) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else { track.scrollBy({ left: step(), behavior: 'smooth' }); }
    }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.agAutoplay === 'true' && !reduceMotion;
    var interval = parseInt(root.dataset.agInterval, 10) || 5000;
    var inView = false, focused = false, holdUntil = 0;
    function pauseFor(ms) { holdUntil = Date.now() + ms; }

    // Manual nav: advance + briefly hold autoplay so we don't fight the user.
    if (prev) prev.addEventListener('click', function () { goPrev(); pauseFor(interval * 2); });
    if (next) next.addEventListener('click', function () { goNext(); pauseFor(interval * 2); });
    // Swipe / drag on the track also briefly holds autoplay.
    ['touchstart', 'pointerdown'].forEach(function (e) {
      track.addEventListener(e, function () { pauseFor(interval * 2); }, { passive: true });
    });
    // Keyboard focus pauses while a slide is focused (accessibility).
    root.addEventListener('focusin', function () { focused = true; });
    root.addEventListener('focusout', function () { focused = false; });

    if (autoplay) {
      // NOTE: no pause-on-hover — the section is full-bleed, so hover-pause
      // would keep it stopped almost the whole time on desktop.
      setInterval(function () {
        if (!inView || focused || Date.now() < holdUntil) return;
        goNext();
      }, interval);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { inView = en.isIntersecting; });
        }, { threshold: 0 }).observe(root);
      } else { inView = true; }
    }
  }
  function boot() { document.querySelectorAll('[data-ag-gallery]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  function agUpdateOpenStatus(){
    if (!document.getElementById('ag-open-status-style')) {
      var s = document.createElement('style');
      s.id = 'ag-open-status-style';
      s.textContent = '@keyframes agPulse { 0%{box-shadow:0 0 0 0 rgba(22,163,74,0.55)} 70%{box-shadow:0 0 0 8px rgba(22,163,74,0)} 100%{box-shadow:0 0 0 0 rgba(22,163,74,0)} }';
      document.head.appendChild(s);
    }
    var el = document.querySelector('.ag-open-status');
    if(!el) return;
    var d = new Date();
    var day = d.getDay();
    var h = d.getHours();
    var m = d.getMinutes();
    var mins = h*60 + m;
    // Lietuvos nedarbo dienos (oficialios šventės) 2026–2029
    var pad = function(n){ return n < 10 ? '0'+n : ''+n; };
    var ymd = d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate());
    var md = ymd.slice(5);
    var fixedHolidays = {
      '01-01': 'Naujieji metai',
      '02-16': 'Valstybės atkūrimo diena',
      '03-11': 'Nepriklausomybės atkūrimo diena',
      '05-01': 'Tarptautinė darbo diena',
      '06-24': 'Joninės',
      '07-06': 'Valstybės diena',
      '08-15': 'Žolinės',
      '11-01': 'Visų šventųjų diena',
      '11-02': 'Vėlinės',
      '12-24': 'Kūčios',
      '12-25': 'Šv. Kalėdos',
      '12-26': 'Antroji Kalėdų diena'
    };
    var movableHolidays = {
      '2026-04-05':'Velykos','2026-04-06':'Velykų pirmadienis','2026-05-03':'Motinos diena','2026-06-07':'Tėvo diena',
      '2027-03-28':'Velykos','2027-03-29':'Velykų pirmadienis','2027-05-02':'Motinos diena','2027-06-06':'Tėvo diena',
      '2028-04-16':'Velykos','2028-04-17':'Velykų pirmadienis','2028-05-07':'Motinos diena','2028-06-04':'Tėvo diena',
      '2029-04-01':'Velykos','2029-04-02':'Velykų pirmadienis','2029-05-06':'Motinos diena','2029-06-03':'Tėvo diena'
    };
    var holidayName = function(date){
      var y = date.getFullYear() + '-' + pad(date.getMonth()+1) + '-' + pad(date.getDate());
      return movableHolidays[y] || fixedHolidays[y.slice(5)] || null;
    };
    var holidayToday = holidayName(d);
    var open = !holidayToday && (day >= 1 && day <= 5) && (mins >= 540 && mins < 1080);
    var dot = el.querySelector('.ag-open-dot');
    var txt = el.querySelector('.ag-open-text');
    if(open){
      el.style.color = '#15803d';
      dot.style.background = '#16a34a';
      dot.style.animation = 'agPulse 2s infinite';
      txt.textContent = 'Šiuo metu dirbame';
    } else {
      el.style.color = '#b91c1c';
      dot.style.background = '#dc2626';
      dot.style.animation = 'none';
      // Suskaičiuoti kada atsidarome (artimiausia darbo diena 9:00)
      var dayNamesLower = ['sekmadienį','pirmadienį','antradienį','trečiadienį','ketvirtadienį','penktadienį','šeštadienį'];
      var openToday = !holidayToday && day >= 1 && day <= 5 && mins < 540;
      var nextLabel;
      if (openToday) {
        nextLabel = 'šiandien 9:00';
      } else {
        var next = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        next.setDate(next.getDate() + 1);
        for (var i = 0; i < 14; i++) {
          var nd = next.getDay();
          if (nd >= 1 && nd <= 5 && !holidayName(next)) break;
          next.setDate(next.getDate() + 1);
        }
        var diff = Math.round((next - new Date(d.getFullYear(), d.getMonth(), d.getDate())) / 86400000);
        if (diff === 1) nextLabel = 'rytoj 9:00';
        else nextLabel = dayNamesLower[next.getDay()] + ' 9:00';
      }
      if (holidayToday) {
        txt.textContent = 'Šiandien ' + holidayToday + ' · Atsidarome ' + nextLabel;
      } else {
        txt.textContent = 'Atsidarome ' + nextLabel;
      }
    }
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(agUpdateOpenStatus, { timeout: 2000 });
  } else {
    setTimeout(agUpdateOpenStatus, 0);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    function handleBreakpoint() {
      const isLarge = window.matchMedia(theme.mediaQueries.md).matches;
      document.querySelectorAll('.js-mega-nav > details').forEach((el) => {
        if (isLarge) {
          el.open = true;
        } else {
          el.open = false;
        }
      });
    }

    handleBreakpoint();
    window.addEventListener('resize', handleBreakpoint);
  });

  } catch(e) { console.error(e); }
})();
})();
